import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";

import CenteredWrapper from 'ui/CenteredWrapper';
import Heading from 'ui/Heading';
import { FlexItem, HR } from 'components/forms/Forms.styles';
import BlogDetailsFrom from './BlogDetailsForm';
import AccessDenied from 'components/AccessDenied';

const EditBlogPage = () => {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const isAdmin = useSelector((state) => state.user.isAdmin);
  const { blogId } = useParams();
  const [blogData, setBlogData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    api
      .get(`${API_BASE}/api/blog/find-by-id?blogId=${blogId}`)
      .then((res) => {
        // console.log('============= fetch blog details response: ', res);
        if (res.status == 200) {
          setBlogData(res.data?.data);
        }
      })
      .catch(() =>
        console.log('failed to fetch blog details data, promptId: ', blogId)
      );
  }, [blogId]);

  const updateBlog = async (values, status) => {
    // console.log('create blog with values: ', values);
    api
      .post(`${API_BASE}/api/blog/update`, { ...values, status })
      .then((res) => {
        if (res.status == 200) {
          const blogId = res.data?.data;
          // navigate(`/relay-prompt/${blogId}`);
          console.log('successfully edit blog: ', blogId);
        }
      })
      .catch(() => alert('Failed to update a blog.'))
      .finally(() => setIsSubmitting(false));
  };

  if (!isAuthenticated || !isAdmin) {
    return <AccessDenied />;
  }

  return (
    <CenteredWrapper
      display="flex"
      justifyContent="start"
      flexDirection="column"
      mt="80px"
      minHeight="calc(100vh - 180px)"
      maxWidth="900px"
    >
      <FlexItem>
        <Heading variant="h2">New Blog</Heading>
      </FlexItem>
      <HR className="light" />
      <BlogDetailsFrom
        data={blogData}
        updateBlog={updateBlog}
        isDisabled={isSubmitting}
        isEdit={true}
      />
    </CenteredWrapper>
  );
};

export default EditBlogPage;
